var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.49833 1.5L4.4893 4.49097M16.4983 16.5L13.5077 13.5093M10.5607 14.6872C10.0548 14.7831 9.5326 14.8333 8.99871 14.8333C5.26734 14.8333 2.10875 12.3809 1.04688 8.99997C1.33596 8.07958 1.78042 7.22801 2.34953 6.47598M7.23056 7.23223C7.68297 6.77982 8.30797 6.5 8.99833 6.5C10.379 6.5 11.4983 7.61929 11.4983 9C11.4983 9.69036 11.2185 10.3154 10.7661 10.7678M7.23056 7.23223L10.7661 10.7678M7.23056 7.23223L4.4893 4.49097M10.7661 10.7678L4.4893 4.49097M10.7661 10.7678L13.5077 13.5093M4.4893 4.49097C5.78915 3.65295 7.33713 3.16667 8.9987 3.16667C12.7301 3.16667 15.8887 5.61909 16.9505 9.00003C16.3614 10.8756 15.1271 12.4654 13.5077 13.5093",
    stroke: "#AE3EC9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.103c7e6246bffcb91d038a2e50efec9c.svg";
export { ForwardRef as ReactComponent };